import { create } from 'zustand';
import { createDI } from '../../../context/di/di';
import { ApiError, ApiResponse, useApi } from '../../../api/api';
import { CsvListRequest } from '../../../model/csvlist_request';
import { SpreadSheetData, SpreadSheetReponse } from '../../../model/spread_sheet_response';

/**
 * 作業計画参照・更新画面 アクションを管理するための DI コンテキスト(アクション)
 */
export type TaskEditAction = {
  /**
   * 作業計画一覧取得
   * @param item
   */
  getCsvList: (item: CsvListRequest) => Promise<SpreadSheetData>;

  /**
   * CSVダウンロード
   * @param item
   */
  getCsvDownload: (item: CsvListRequest) => Promise<ApiResponse>;
};

/**
 * 作業計画参照・更新画面 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<TaskEditAction>();
export { Provider as TaskEditProvider, use as useTaskEditStore };

/**
 * 作業計画参照・更新画面 状態とアクション
 */
export const defaultTaskEditStore = () => {
  const api = useApi();

  return create<TaskEditAction>(() => {
    return {
      getCsvList: async (item: CsvListRequest) => {

        // リクエストパラメータ生成
        let param = '';
        param += `targetFile=${item.targetFile}`;
        param += `&year=${item.year}`;
        param += `&dateType=${item.dateType}`;
        param += `&month=${item.month}`;
        if (item.divisionId != null && item.divisionId !== 0) {
          param += `&divisionId=${item.divisionId}`;
        }
        if (item.floorId != null && item.floorId !== 0) {
          param += `&floorId=${item.floorId}`;
        }
        if (item.blockId != null && item.blockId !== 0) {
          param += `&blockId=${item.blockId}`;
        }
        param += `&page=${item.page}&count=50`;

        const resp = await api.path(`/api/csv?${param}`).get();
        if (resp.isError) {
          throw new ApiError(resp);
        }
        return resp.data as SpreadSheetData;

      },
      getCsvDownload: async (item: CsvListRequest) => {

        // リクエストパラメータ生成
        let param = '';
        param += `targetFile=${item.targetFile}`;
        param += `&year=${item.year}`;
        param += `&dateType=${item.dateType}`;
        param += `&month=${item.month}`;
        if (item.divisionId != null && item.divisionId !== 0) {
          param += `&divisionId=${item.divisionId}`;
        }
        if (item.floorId != null && item.floorId !== 0) {
          param += `&floorId=${item.floorId}`;
        }
        if (item.blockId != null && item.blockId !== 0) {
          param += `&blockId=${item.blockId}`;
        }

        console.log(`作業計画CSVダウンロードAPI ${param}`);

        const resp = await api.path(`/api/csv/download?${param}`)
          .useResponseTypeBlob()
          .get();
        if (resp.isError) {
          throw new ApiError(resp);
        }

        return resp;

      },
    };
  });
};
